
import { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import { Alert, AlertTitle } from '@mui/material'

import InfoOutlineIcon from "@mui/icons-material/InfoOutline";

import { RootState } from '../store';

import { ValidarFirmaElectronica } from '../connections/auth/AuthConnection';

export const AlertFirmaElectronica = () => {

    const { open } = useSelector( ( state: RootState ) => state.loading );

    const [firmaElectronica, setFirmaElectronica] = useState( false );
    const [diasExpiracionFirmaElectronica, setDiasExpiracionFirmaElectronica] = useState( 0 );

    useEffect(() => {
         
           async function obtener(){
   
               await ValidarFirmaElectronica().then( resp => {
   
                const { diasExpiracionFirmaElectronica, firmaElectronica } = resp;

                   setFirmaElectronica( firmaElectronica ?? false );
                   setDiasExpiracionFirmaElectronica( diasExpiracionFirmaElectronica ?? 0 );
         
               });           
   
           }
   
           obtener();
   
    }, [])   

    return (
        <>
            {
                ( !open && ( firmaElectronica && diasExpiracionFirmaElectronica <= 10 ) )
                &&

                    <Alert icon={ <InfoOutlineIcon /> } variant='filled' severity={ diasExpiracionFirmaElectronica <= 0 ? 'error' : 'warning' } sx={{ mb: 2 }}>

                        <AlertTitle sx={{ fontWeight: 'bold' }}>Advertencia.</AlertTitle>                        
                        {
                            diasExpiracionFirmaElectronica <= 0 
                            ?
                                'La firma electronica se encuentra vencida o expirada.'
                            :
                                diasExpiracionFirmaElectronica === 1
                                ?
                                    <> La fecha de vencimiento o expiración de la firma electronica esta proxima queda <strong>{ diasExpiracionFirmaElectronica } dia.</strong> </>                     
                                :                        
                                    <> La fecha de vencimiento o expiración de la firma electronica esta proxima quedan <strong>{ diasExpiracionFirmaElectronica } dia(s).</strong> </>              
                        }
                    </Alert>
            }
        </>
    )
}
